export const init = () => {
 const components = document.querySelectorAll('.js-expandable-set');
 if (!components.length) return;

 components.forEach((component) => {
  const itemsContainer = component.querySelector('.js-expandable-set-list');
  const items = Array.from(itemsContainer.children);
  const showMoreBtn = component.querySelector('.js-expandable-set-button');
  let visibleItemCount = Number(component.dataset.itemsShown);
  const itemCountToExpand = Number(component.dataset.itemsToExpand);
  
  items.forEach((item, index) => {
    item.style.display = index < visibleItemCount ? 'block' : 'none';
  });
  
  if (!showMoreBtn) return;
  
  showMoreBtn.addEventListener('click', () => {
    const nextVisibleCount = visibleItemCount + itemCountToExpand;

    items.forEach((item, index) => {
      if (index < nextVisibleCount) {
        item.style.display = 'block';
      }
    });

    visibleItemCount = nextVisibleCount;
    console.log(visibleItemCount);

    if (visibleItemCount >= items.length) {
      showMoreBtn.style.display = 'none';
    }
  });
 });
};